import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useClient } from './useClient';
import { getLocation } from '../utils/helpers';

export function useToggleByHash(hash, onOpenHook, onCloseHook) {
  const router = useRouter();
  const isClient = useClient();
  const location = getLocation();

  const url = useMemo(() => {
    if (!isClient) return null;
    return new URL(router.asPath, location.origin);
  }, [isClient, router.asPath, location.origin]);

  const isOpen = useMemo(() => {
    if (!isClient) return false;
    return location.hash === hash;
  }, [isClient, hash, router.asPath, location.hash]);

  function open() {
    if (!url) return;
    onOpenHook?.();
    url.hash = hash;
    router.push(url);
  }

  function close() {
    if (!url) return;
    onCloseHook?.();
    url.hash = '';
    router.push(url);
  }

  return { open, close, isOpen };
}
